import { connect } from 'react-redux'
import SearchResultsSkeleton from 'pages/search/SearchResultsSkeleton'

const mapStateToProps = state => ({
  windowHeight: state.layout.windowHeight,
  headerHeight: state.layout.headerHeight,
  flavour: state.layout.flavour,
  searchType: state.search.searchType,
  pageView: state.page.pageView
})

export default connect(mapStateToProps, null)(SearchResultsSkeleton)
